export default __webpack_public_path__ + "b2ce7509fb4d17fbf72ab013a4639828.gif";